/**
 * P0-158: Casino is the administrative console for MCP users; the web builder
 * lives behind this flag.
 *
 * WEB_BUILDER_ENABLED (from VITE_WEB_BUILDER_ENABLED, default 'true'):
 *
 *  - true (default): today's behavior — chat/workspace builder is the primary
 *    surface, `/` routes authed users to /workspace.
 *  - false: builder hidden. `/` shows McpLanding to anon visitors and routes
 *    authed users to /mcp/dashboard; /chat and /workspace redirect there;
 *    pending-prompt auto-build, chat nav affordances, and post-auth /chat
 *    redirects are all disabled. Data/library/automations/settings stay.
 *
 * Flip = one line in .env.production + a casino CDN deploy; rollback is the
 * same line reverted. Backend REST builds (ship_spec) are unaffected.
 */
export const WEB_BUILDER_ENABLED: boolean =
  ((import.meta.env.VITE_WEB_BUILDER_ENABLED as string) || 'true') !== 'false';

/** Where successful auth lands (RegisterForm/LoginForm/Complete/GoogleCallback). */
export const POST_AUTH_HOME = WEB_BUILDER_ENABLED ? '/chat' : '/mcp/dashboard';

/**
 * P0-164: Stripe-only monetization front door. The AGENT (crypto) rail stays
 * fully functional in the API/MCP for OIF and explicit opt-ins, but its
 * builder-facing UI (mode selector, AGENT pricing, payout-wallet input,
 * token earnings sections) is hidden unless this flag is on.
 *
 * AGENT_RAIL_ENABLED (from VITE_AGENT_RAIL_ENABLED, default 'false' — note
 * the inverse default vs WEB_BUILDER_ENABLED: crypto is opt-in at launch).
 * Grandfather rule: earnings surfaces still show AGENT sections to builders
 * with nonzero AGENT history or a pending payout action, flag or no flag.
 *
 * Flip = one line in .env.production + a casino CDN deploy.
 */
export const AGENT_RAIL_ENABLED: boolean =
  (import.meta.env.VITE_AGENT_RAIL_ENABLED as string) === 'true';
